import { defineRecipe } from '@chakra-ui/react';

export const headingRecipe = defineRecipe({
  base: {
    margin: '0',
    fontWeight: 500,
  },
  variants: {
    size: {
      xs: { textStyle: 'xs' },
      sm: { textStyle: 'sm' },
      md: { textStyle: 'md' },
      lg: { textStyle: 'lg' },
      xl: { textStyle: 'xl' },
    },
  },
});

export default headingRecipe;
